if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentScale = 1;
        this.querySelector('.product-lightbox-swiper')?.addEventListener('pointerup', (event) => {
          event.stopPropagation();
        });
      }

      hide() {
        this.resetZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.initLightbox();
        this.showActiveMedia();
      }

      initLightbox() {
        if (this.lightboxSwiper || typeof Swiper === 'undefined') return;

        const root = this.querySelector('.product-lightbox-swiper');
        if (!root) return;

        this.lightboxSwiper = new Swiper(root, {
          slidesPerView: 1,
          spaceBetween: 0,
          watchOverflow: true,
          resistanceRatio: 0.65,
          keyboard: {
            enabled: true,
          },
          pagination: {
            el: this.querySelector('.product-lightbox-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: this.querySelector('.product-lightbox-nav--next'),
            prevEl: this.querySelector('.product-lightbox-nav--prev'),
          },
        });

        this.lightboxSwiper.on('slideChange', () => this.resetZoom());
        this.bindZoom(root);
      }

      activeImage() {
        return this.querySelector('.product-lightbox-swiper .swiper-slide-active img');
      }

      applyZoom(img, scale, origin) {
        if (!img) return;

        this.currentScale = scale;
        if (origin) img.style.transformOrigin = origin;
        img.style.transform = scale > 1 ? `scale(${scale})` : '';
        img.classList.toggle('is-zoomed', scale > 1);

        if (this.lightboxSwiper) {
          this.lightboxSwiper.allowTouchMove = scale <= 1;
        }
      }

      resetZoom() {
        this.currentScale = 1;
        this.querySelectorAll('.product-lightbox-swiper img').forEach((img) => {
          img.classList.remove('is-zoomed');
          img.style.transform = '';
          img.style.transformOrigin = 'center center';
        });
        if (this.lightboxSwiper) this.lightboxSwiper.allowTouchMove = true;
      }

      toggleZoom(img, point) {
        if (this.currentScale > 1) {
          this.resetZoom();
          return;
        }

        const rect = img.getBoundingClientRect();
        const originX = ((point.clientX - rect.left) / rect.width) * 100;
        const originY = ((point.clientY - rect.top) / rect.height) * 100;
        this.applyZoom(img, 2.4, `${originX}% ${originY}%`);
      }

      touchDistance(touches) {
        const x = touches[0].clientX - touches[1].clientX;
        const y = touches[0].clientY - touches[1].clientY;
        return Math.hypot(x, y);
      }

      bindZoom(root) {
        if (this.zoomBound) return;
        this.zoomBound = true;

        root.addEventListener('click', (event) => {
          if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          if (event.target.closest('.product-lightbox-nav, .product-lightbox-pagination')) return;

          const img = event.target.closest('.swiper-slide-active img');
          if (!img) return;
          this.toggleZoom(img, event);
        });

        root.addEventListener(
          'touchstart',
          (event) => {
            if (event.touches.length === 2) {
              this.pinching = true;
              this.startDistance = this.touchDistance(event.touches);
              this.startScale = this.currentScale || 1;
              if (this.lightboxSwiper) this.lightboxSwiper.allowTouchMove = false;
            }
          },
          { passive: true }
        );

        root.addEventListener(
          'touchmove',
          (event) => {
            if (!this.pinching || event.touches.length !== 2) return;
            event.preventDefault();

            const img = this.activeImage();
            const scale = Math.min(4, Math.max(1, this.startScale * (this.touchDistance(event.touches) / this.startDistance)));
            this.applyZoom(img, scale);
          },
          { passive: false }
        );

        root.addEventListener('touchend', (event) => {
          if (this.pinching) {
            this.justPinched = true;
            setTimeout(() => {
              this.justPinched = false;
            }, 300);
            this.pinching = false;
            if (this.currentScale <= 1.05) this.resetZoom();
            return;
          }

          if (event.changedTouches.length !== 1 || this.justPinched) return;

          const now = Date.now();
          if (now - (this.lastTap || 0) < 280) {
            const img = event.target.closest('.swiper-slide-active img');
            if (img) this.toggleZoom(img, event.changedTouches[0]);
          }
          this.lastTap = now;
        });
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        if (!mediaId) return;

        this.resetZoom();

        const slides = this.querySelectorAll('.product-lightbox-swiper .swiper-slide');
        let index = 0;
        slides.forEach((slide, i) => {
          if (slide.getAttribute('data-media-id') === mediaId) index = i;
        });

        if (this.lightboxSwiper) {
          this.lightboxSwiper.slideTo(index, 0);
          this.lightboxSwiper.update();
        }

        const activeMedia = this.querySelector(
          `.product-lightbox-swiper .swiper-slide[data-media-id="${mediaId}"] deferred-media`
        );
        if (activeMedia && !activeMedia.getAttribute('loaded')) {
          activeMedia.loadContent?.();
        }
      }
    }
  );
}
